import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { ContentWrapper } from 'components/utilities/pageStyles';

export const Wrapper = styled(ContentWrapper)`
  background-color: ${themeStyle.varBackgroundAlt};
  border-top: ${({ newBackground }) =>
    newBackground ? `1px solid ${themeStyle.varInkSuperLight}` : 'none'};
`;

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 100%;
  padding: 12px;
  padding-top: 50px;
  padding-bottom: 30px;

  ${QUERIES.tabletAndUp} {
    flex-direction: row;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 294px;
`;

export const RightColumn = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  flex-grow: 1;
  gap: 50px;
`;

export const CopyrightText = styled.div`
  display: block;
  margin-top: auto;
  font-size: ${themeStyle.fontSize11};
  font-weight: ${themeStyle.fontSemiBold};
  color: ${themeStyle.varInkMedium};
`;
